import React from 'react';
import Image from 'next/image';
import { s3Static } from '../../../utils/constants';

export const CommonBanner = ({ locality, countryName, bannerText, category }) => {
  const categoryImages = {
    'personal-trainer': {
      src: s3Static + 'personal-trainer/personal-trainer-singapore.jpeg',
      alt: 'Personal Trainer Singapore',
    },
    'financial-adviser-singapore': {
      src: s3Static + 'Financial-Adviser.jpg',
      alt: 'Financial Adviser Singapore',
    },
    'property-agent': {
      src: s3Static + 'Property-Agent-Singapore.jpg',
      alt: 'Property Agent Singapore',
    },
  };

  const imageData = categoryImages[category] || categoryImages['personal-trainer'];

  return (
    <div className="-mt-14 relative w-full aspect-[4/2] md:aspect-[3/1] mb-2 overflow-hidden">
      <Image
        src={imageData.src}
        alt={imageData.alt}
        fill
        priority={true}
        sizes="100vw"
        style={{ objectFit: 'cover', objectPosition: 'center' }}
        className="bg-linear-to-br from-slate-800 to-orange-300"
      />
      <div className="absolute flex justify-between items-center h-full w-full">
        <div className="bg-black/30 rounded-lg w-fit mx-auto p-2 space-y-2 text-center text-white">
          <h1 className="text-2xl md:text-4xl">
            <strong>
              {bannerText}
              <br />
              <span className="md:text-lg">
                {locality && <span>{locality}, </span>}
                {countryName}
              </span>
            </strong>
          </h1>
        </div>
      </div>
    </div>
  );
};
